<template>
	<div class="video">	
		<div class="empty"></div>		
		<div class="form" v-if="doctorCode=='none'">
			<div class="title">说明：特定会员方能享有视频医生权益，具体请联系您的客户经理。您确定拥有视频医生权益后，请准确填写以下资料以便激活您的视频医生。</div>			
			<div class="row">
				<input @blur="fixScroll" class="input2" v-model="addForm.name"  placeholder="请输入姓名" />
				<input class="input1" placeholder="性别" v-model="sexName" readonly="true" @click="showSexDropBox()" />
			</div>
			<div class="row">
				<input class="input" readonly="true" v-model="addForm.birthDate" placeholder="出生日期" @click="handleDate()"/>
			</div>
			<div class="row">
				<input @blur="fixScroll" class="input" v-model="addForm.mobile" placeholder="手机号码" />
			</div>
			<div class="row">
				<input @blur="fixScroll" class="input2" v-model="addForm.code" placeholder="请输入图片中的数字" /><img :src="ImgVerificationSrc" @click="changeValidateCode()" />
			</div>
			<div class="row">
				<div class="btn" @click="submit()">立即激活</div>
			</div>
		</div>
		<div class="userInfo" v-else-if="doctorCode=='success'">
			<div class="title">
				{{expireDate}}
			</div>
			<div class="barCode">	
				<div class="whiteBg">
					<img :src="wxImageUrl" />	
				</div>				
			</div>
			<div class="tip">
				长按二维码呼叫您的私人医生
			</div>
			<div class="tip_small">
				{{cardDesc}}
			</div>
		</div>		
		<div class="userInfo" v-else-if="doctorCode=='expired'">
			<div class="tip">
				您服务有效期截止{{expireDate}}
			</div>			
			<div class="title">如需继续使用服务，请联系发卡机构</div>			
		</div>		
		<div class="userInfo" v-else-if="doctorCode=='active'">
			<div class="title">
				{{expireDate}}
			</div>					
			<div class="title">
				{{times}}
			</div>		
			<div class="tip">
				如需继续使用该该服务，需要您再次激活。
			</div>	
			<div class="tip_small" v-if="cardDesc">
				{{cardDesc}}
			</div>
			<div class="btn" @click="activeUserAgain()">立即激活</div>
		</div>
		<mask-box
		  :isShow="isSexShow"
		  @handle-close="sexClose"
		  :dataList="sexList"
		  title="性别"
		  @handle-select="sexSelect"
		></mask-box>
		<!--
		<alert-box-item :paramObj="paramObj" @handle-cert="activeUserInfo"></alert-box-item>
		-->
	</div>
</template>

<script>

	import { getApi, postApi } from "../../api/index.js";
	import AlertBox from "../../components/alert-box";
	import MaskBox from "../../components/mask-box";
	import { get } from "http";
	import { Dialog } from 'vant';	
	import {AppIdName,TokenName,jxAppId} from '../../api/api.js';
	
	export default {
	  components: {
	    "mask-box": MaskBox,
		//"alert-box-item": AlertBox,
		[Dialog.Component.name]: Dialog.Component,
	  },
	  data() {
	    return {
	      addRef: false,
	      select: false,
	      isSexShow: false,
	      sexName: "",
	      treatyIsShow: false,	
	      sexList: [],
	      addForm: {
	        birthDate: "",
	        mobile: "",
	        name: "",	        
	        sexCode: "",
			code:"",
	      },
	      isShowDate: false,
	      dateMode: "",	      
	      sexCode: "",	 
		  ImgVerificationSrc:"",
		  lifeToken: '',
		  paramObj: {},
		  doctorCode:"none",
		  expireDate:"",
		  cardDesc:"",
		  times:"",
		  wxImageUrl:"",
		  name:"",
	    };
	  },
	  created: function() {
		let appId = localStorage.getItem(AppIdName);
		this.lifeToken = localStorage.getItem(TokenName+appId || "");		  
		this.getUserInfo();	    
	  },	
	  methods: {
		fixScroll() {		
		   let u = navigator.userAgent;		
		   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端		
		   if (isiOS) {		
		    window.scrollTo(0, 0);		
		   }		
		},
	    submit() {				
	      if (this.addForm.name == "") {
	        this.$toast("请输入姓名");
	        return;
	      } else if (!this.addForm.sexCode) {
	        this.$toast("请选择性别");
	        return;
	      } else if (!this.addForm.birthDate) {
	        this.$toast("请输入出生日期");
	        return;
	      } else if (this.addForm.mobile == "") {
	        this.$toast("请输入手机号码");
	        return;
	      } else if (this.addForm.code == "") {
	        this.$toast("请输入验证码");
	        return;
	      }	
		  let phonereg = /^[1][1,2,3,4,5,7,8,9][0-9]{9}$/
		  if (this.addForm.mobile.length <= 0 ||
				this.addForm.mobile.length > 11) {
		    this.$toast('请输入11位手机号码')
		    return
		  } else if (!phonereg.test(this.addForm.mobile)) {
		    this.$toast('请输入正确手机号码')
		    return
		  }
		  this.showUserConfirmDialog();
	    },
		
		showUserConfirmDialog(){			
			Dialog.confirm({
			  title: '温馨提示',
			  message: '服务激活后请在有效期内及时使用，过期不能使用，是否继续激活？',
			}).then(() => {
			    this.activeUserInfo()
			}).catch(() => {});			
		},
		
		//激活用户资料
		activeUserInfo(){		
			let that = this;
			postApi({
				url: `/video/active`,
				query: {
					name: this.addForm.name,
					sex: this.addForm.sexCode,
					birthday:this.addForm.birthDate,
					mobile:this.addForm.mobile,
					code:this.addForm.code,
					userCode:this.lifeToken
				}
			 }).then(res =>{
				 //console.log(res)
				 if (res.resCode==0){
					 let data = res.data
					 that.doctorCode = data.code
					 if (data.code == 'success'){
					 	that.wxImageUrl = data.wxImageUrl;
					 	that.expireDate = data.expireDate;
						that.cardDesc = data.cardDesc;
					 }
				 }else{
					that.$toast(res.resMsg)
				 }
				 that.changeValidateCode();
			 }).catch(res =>{
			     that.$toast("请确定网络是否正常")
			 })
		},
		activeUserAgain(){			
			let that = this;
			postApi({
				url: `/video/activeAgain`,
				query: {a:1}
			 }).then(res =>{				 
				 if (res.resCode==0){
					 let data = res.data
					 that.doctorCode = data.code
					 if (data.code == 'success'){
					 	that.wxImageUrl = data.wxImageUrl;
					 	that.expireDate = data.expireDate;
						that.cardDesc = data.cardDesc;
					 }
				 }else{
					that.$toast(res.resMsg)
				 }				 
			 }).catch(res =>{
			     that.$toast("请确定网络是否正常")
			 })
		},
		getUserInfo(){
			let that = this;
			getApi({ url: "/video/getUserInfo", query: {} })
			  .then(res => {
			    if (res && res.resCode == 0) {
					let data = res.data;
					that.doctorCode = data.code;
					if (data.code == 'none'){
						that.addForm.name = data.name;
						that.addForm.sexCode = data.sexCode;
						that.sexName = data.sexName;
						that.addForm.birthDate = data.birthDay;
						that.addForm.mobile = data.mobile;						
						that.getSexList();
						that.changeValidateCode();
					}else if (data.code == 'success'){
						that.wxImageUrl = data.wxImageUrl;
						that.expireDate = data.expireDate;
						that.cardDesc = data.cardDesc;
					}else if (data.code == 'expired'){
						that.expireDate = data.expireDate;
						that.cardDesc = data.cardDesc;
					}else if (data.code == 'active'){						
						that.times = data.times;
						that.cardDesc = data.cardDesc;
					}					
			    }else{
					that.$toast(res.resMsg)
				}
			  })
			  .catch(res => {
					that.$toast("请确定网络是否正常")
			  });
		},
		changeValidateCode(){
			let date = new Date()
			this.ImgVerificationSrc = `https://zg.lifejiankang.com/api/validate/kaptcha.jpg?userCode=${this.lifeToken}&time=${date}`
		},
	    onChange(date) {	      
	      this.addForm.birthDate = date.format("YYYY-MM-DD");
	      this.isShowDate = false;	      
	    },
		showSexDropBox(){
			this.isSexShow = true;
		},
	    handleDate() {
	      let date = new Date();
	      let y = date.getFullYear();
	      let m = this.tf(date.getMonth() + 1);
	      let d = this.tf(date.getDate());
	      let time = y + "-" + m + "-" + d;
	      // this.isShowDate = true
	      this.$picker.show({
	        type: "datePicker",
	        date: this.addForm.birthDate || "1990-01-01",
	        endTime: time, //截至时间
	        startTime: "1880-01-01", //开始时间
	        onOk: date => {
	          this.addForm.birthDate = date;
	        }
	      });
	    },
	    tf(i) {
	      return (i < 10 ? "0" : "") + i;
	    },
	    treatyClick() {
	      this.treatyIsShow = true;
	    },
	    
	    sexSelect(item) {
	      this.sexName = item.dicName;
	      this.addForm.sexCode = item.dicCode;
	      this.isSexShow = false;
	    },
	    handleTypeClose() {
	      this.isokShow = false;
	    },
	
	    chooe() {
	      this.select = !this.select;
	    },

	    getSexList() {	      
	      getApi({ url: "/common/dict/SYS_SEX", query: {} })
	        .then(res => {
	          if (res && res.resCode == 0) {
	            this.sexList = res.data;
	          }
	        })
	        .catch(res => {
	          console.log("获取性别类型失败");
	        });
	    },	   	
	    sexClose() {
	      this.isSexShow = false;
	    },	
	    handleClose() {
	      this.treatyIsShow = false;
	    },
	    handle() {
	      this.isokShow = true;
	    }
	  },	  
	};
</script>

<style lang="less" scoped>
	.video{
		width: 100%;
		height: 100%;
		background-image:url(../../assets/image/videoDoctor/video_bg.png);
		background-repeat:no-repeat;
		background-size:100% 100%;		
		-moz-background-size:100% 100%;	
		.empty{
			width: 100%;
			height: 49%;
		}
		.userInfo{
			.title{
				color: #000000;
				font-size: 0.26rem;
				text-align: center;
				margin: 0.2rem 0.8rem;
				padding: 0 0.2rem;
			}
			.tip{
				color: #333333;
				font-size: 0.32rem;
				text-align: center;
				margin: 0.3rem 0rem;
			}
			.tip_small{
				color: #666666;
				font-size: 0.28rem;
				text-align: center;
				margin: 0.3rem 0rem;
			}
			.barCode{
				width: 2.6rem;
				margin: 0.3rem auto;
				padding: 0.35rem;
				background-image:url(../../assets/image/videoDoctor/video_brcode_bg.png);
				background-repeat:no-repeat;
				background-size:100% 100%;		
				-moz-background-size:100% 100%;		
				.whiteBg{
					background-color:white;
					img{
						width: 100%;
						height: 100%;
					}	
				}				
			}
			.btn{
				color: #FFFFFF;
				background-image:url(../../assets/image/videoDoctor/btn_video_bg.png);
				background-repeat:no-repeat;
				background-size:100% 100%;		
				-moz-background-size:100% 100%;	
				height: 100%;
				width: 80%;
				margin: 0 auto;
				text-align: center;
				line-height: 1.2rem;
			}
		}	
			
		.form{
			width: 80%;
			margin:0 auto;
			.title{								
				font-size: 0.26rem;
				color: rgb(102, 102, 102);
				line-height: 0.36rem;
			}
			.row{
				height: 1.06rem;
				display:flex;
				flex-direction: row;
				align-items: center;
				img{					
					height: 80%;					
					border: 0;
					padding: 0 0.5rem;
					width: 20%;
				}
				.input{
					background-color: #F0EEED;
					height: 80%;
					border-radius: 2rem;
					border: 0;
					padding: 0 0.5rem;
					width: 85%;
				}	
				.input1{
					background-color: #F0EEED;
					height: 80%;
					border-radius: 2rem;
					border: 0;
					padding: 0 0.5rem;
					width: 20%;
				}
				.input2{
					background-color: #F0EEED;
					height: 80%;
					border-radius: 2rem;
					border: 0;
					padding: 0 0.5rem;
					flex: 2;
					width: 50%;
				}
				.btn{
					color: #FFFFFF;
					background-image:url(../../assets/image/videoDoctor/btn_video_bg.png);
					background-repeat:no-repeat;
					background-size:100% 100%;		
					-moz-background-size:100% 100%;	
					height: 100%;
					width: 100%;
					text-align: center;
					line-height: 1.06rem;
				}
			}
			
		}
	}	
</style>
